"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Tracking = require("@jobmatchme/tracking/es/provider/Tracking");

var _sendUrlParamToBackend = require("./sendUrlParamToBackend");

var _Authentication = require("../../provider/Authentication");

var _Profile = require("../../provider/Profile");

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _MatchesScreen = _interopRequireDefault(require("../MatchesScreen"));

var _LanguageSkillsModal = require("../LanguageSkillsModal");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Handle an unauthenticated, but signed application by a pc
 * that specifically selected a given joboffer (e.g. from by clicking
 * in a jobletter)
 */
var LikeSigned = function LikeSigned() {
  var _useContext = (0, _react.useContext)(_Authentication.AuthenticationContext),
      user = _useContext.user,
      isLoading = _useContext.isLoading;

  var _useContext2 = (0, _react.useContext)(_Profile.ProfileActionsContext),
      fetchProfile = _useContext2.fetchProfile;

  var _useComponentTracking = (0, _Tracking.useComponentTracking)('LikeSigned'),
      pcDataLayerPush = _useComponentTracking.pcDataLayerPush;

  (0, _react.useEffect)(function () {
    if (isLoading === false && user && user.username) {
      // save returned user to our trackingService
      var userComeBack = sessionStorage.getItem('userComeBack');

      if (!userComeBack) {
        (0, _Tracking.trackEvent)({
          eventName: 'jmmPcLikeSigned',
          pcUuid: user.username,
          payload: {}
        });
        sessionStorage.setItem('userComeBack', 'true');
      }
    }
  }, [isLoading, user]);
  (0, _react.useEffect)(function () {
    if (!isLoading) {
      // Send data from url to backend
      (0, _sendUrlParamToBackend.sendTokenizedJudgement)(user).then(function () {
        return fetchProfile();
      }).then(function (profile) {
        pcDataLayerPush('like', profile, 'jobletter');
      });
    }
  }, [isLoading, user, fetchProfile, pcDataLayerPush]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      user: user ? user.attributes.name : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MatchesScreen.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LanguageSkillsModal.DisplayModalIfEmptyLanguages, {})]
  });
};

var _default = LikeSigned;
exports.default = _default;